/**
 * Created by chenzheyu on 2017/6/21.
 */
import XKinputBox from './src/inputBox.vue'

XKinputBox.intall = function (Vue) {
  Vue.component(XKinputBox.name, XKinputBox)
}

export default XKinputBox



// WEBPACK FOOTER //
// ./src/components/module/inputBox/index.js